import {z} from 'zod';
import {defineToolRegistryManifest} from '../../types/base-tool-types';
import {translationExclusionUpdateZod} from '../../schemas';

const toolName = 'update-all-matching-translation-exclusions' as const;

const argumentZod = z.object({
  kind: z
    .enum(['page-field', 'collection-field', 'component-prop'])
    .describe(
      'Which kind of translation exclusion rules to update -- every rule of this kind for the site is updated.'
    ),
  update: translationExclusionUpdateZod,
});

export const updateAllMatchingTranslationExclusionsManifest =
  defineToolRegistryManifest({
    id: toolName,
    prettyName: 'Update all matching translation exclusion rules',
    prettyStatus: {
      executing: 'Updating translation exclusions…',
      executed: 'Updated translation exclusions',
      failed: 'Updating translation exclusions failed',
    },
    family: 'localization',
    llmTool: {
      name: toolName,
      description:
        'Updates the language and/or trigger scoping of every translation exclusion rule of a given kind for the current site. Provided fields replace the existing values -- they do not merge with them. Use bulk-update-translation-exclusions instead to target specific rules by id.',
      inputSchema: argumentZod,
    },
    type: 'server',
    requiredScopes: ['sites:write'],
    permission: [{resource: 'Site', action: 'update'}],
    confirmBeforeExecuting: true,
  });

export type UpdateAllMatchingTranslationExclusionsArgumentType = z.infer<
  typeof argumentZod
>;
